import { unitDefault, unitTypes } from "@/settings/unitTypes";
export const Boiler = {
  id: "60",
  name: "Caldera",
  mainClass: "Estático",
  subtype: "Vapor",
  variables: [
    {
      type: unitTypes.massFlow,
      unit: unitDefault.massFlow.metric,
      code: "boilerEconomizerFlow",
      groups: "general",
      values: [100, 300, 800, 900],
      min: 0,
      max: 1000
    },
    {
      type: unitTypes.massFlow,
      unit: unitDefault.massFlow.metric,
      code: "boilerSteam",
      groups: "general",
      values: [100, 300, 800, 900],
      min: 0,
      max: 1000
    },
    {
      type: unitTypes.flow,
      unit: "MMSCFD",
      code: "boilerAirFlow",
      groups: "general",
      values: [100, 300, 800, 900],
      min: 0,
      max: 1000
    },
    {
      type: unitTypes.flow,
      unit: "MMSCFD",
      code: "boilerFuelFlow",
      groups: "general",
      values: [100, 300, 800, 900],
      min: 0,
      max: 1000
    },
    {
      type: unitTypes.percentage,
      unit: unitDefault.percentage.metric,
      code: "boilerExcessOxygen",
      groups: "general",
      values: [10, 30, 80, 90],
      min: 0,
      max: 100
    },
    {
      type: unitTypes.percentage,
      unit: unitDefault.percentage.metric,
      code: "boilerSteamLevel",
      groups: "general",
      values: [10, 30, 80, 90],
      min: 0,
      max: 100
    },
    {
      type: unitTypes.pressure,
      unit: unitDefault.pressure.metric,
      code: "boilerSteamPressure",
      groups: "general",
      values: [100, 300, 800, 900],
      min: 0,
      max: 1000
    },
    {
      type: unitTypes.temperature,
      unit: unitDefault.temperature.metric,
      code: "boilerSteamTemperature",
      groups: "general",
      values: [100, 300, 800, 900],
      min: 0,
      max: 1000
    },
    {
      type: unitTypes.pH,
      unit: unitDefault.pH.metric,
      code: "boilerPH",
      groups: "general",
      values: [1, 2, 5, 6],
      min: 0,
      max: 14
    }
  ],
  operationalValues: [
    {
      value: 0,
      type: unitTypes.temperature,
      unit: unitDefault.temperature.metric,
      code: "boilerOperationalTemperature"
    },
    {
      value: 0,
      type: unitTypes.temperature,
      unit: unitDefault.temperature.metric,
      code: "boilerDesignTemperature"
    },
    {
      value: 0,
      type: unitTypes.pressure,
      unit: unitDefault.pressure.metric,
      code: "boilerDesignPressure"
    },
    {
      value: 0,
      type: unitTypes.pressure,
      unit: unitDefault.pressure.metric,
      code: "boilerOperationalPressure"
    },
    {
      value: 0,
      type: unitTypes.massFlow,
      unit: unitDefault.massFlow.metric,
      code: "boilerSteamCapacity"
    }
  ]
};
